/* eslint-disable indent */
import React from "react";
import styles from "../EditableTag.module.css";

export const ToolbarComponent = ({
	selectedElementData,
	updateElementProperty,
	handleZoomOut,
	handleZoomIn,
	handleZoomReset,
	zoom,
	exportToPDF,
	printPDF,
	resetToInitialState
}) => (
	<div className={styles.toolbar}>
		<div className={styles.toolbarGroup}>
			<button className={styles.toolbarButton} onClick={exportToPDF}>
				Baixar PDF
			</button>
			<button className={styles.toolbarButton} onClick={printPDF}>
				Imprimir PDF
			</button>
			<button className={styles.toolbarButton} onClick={resetToInitialState}>
				Resetar Etiqueta
			</button>
		</div>

		<div className={styles.toolbarGroup}>
			<span className={styles.toolbarLabel}>Zoom:</span>
			<button className={styles.toolbarButton} onClick={handleZoomOut}>
				-
			</button>
			<span className={styles.toolbarLabel}>{Math.round(zoom * 100)}%</span>
			<button className={styles.toolbarButton} onClick={handleZoomIn}>
				+
			</button>
			<button className={styles.toolbarButton} onClick={handleZoomReset}>
				Resetar Zoom
			</button>
		</div>

		{selectedElementData && selectedElementData.type === "text" && (
			<>
				<div className={styles.toolbarGroup}>
					<span className={styles.toolbarLabel}>Fonte:</span>
					<select
						className={styles.toolbarSelect}
						value={selectedElementData.fontFamily}
						onChange={(e) => updateElementProperty("fontFamily", e.target.value)}
					>
						<option value="Roboto, Arial, sans-serif">Roboto</option>
						<option value="Arial, sans-serif">Arial</option>
						<option value="Times New Roman, serif">Times New Roman</option>
						<option value="Courier New, monospace">Courier New</option>
					</select>
				</div>

				<div className={styles.toolbarGroup}>
					<span className={styles.toolbarLabel}>Tamanho:</span>
					<input
						type="number"
						className={styles.toolbarInput}
						value={selectedElementData.fontSize}
						onChange={(e) => updateElementProperty("fontSize", parseInt(e.target.value))}
						min="4"
						max="72"
					/>
				</div>

				<div className={styles.toolbarGroup}>
					<span className={styles.toolbarLabel}>Peso:</span>
					<select
						className={styles.toolbarSelect}
						value={selectedElementData.fontWeight}
						onChange={(e) => updateElementProperty("fontWeight", e.target.value)}
					>
						<option value="normal">Normal</option>
						<option value="bold">Negrito</option>
					</select>
				</div>

				<div className={styles.toolbarGroup}>
					<span className={styles.toolbarLabel}>Alinhamento:</span>
					<select
						className={styles.toolbarSelect}
						value={selectedElementData.textAlign}
						onChange={(e) => updateElementProperty("textAlign", e.target.value)}
					>
						<option value="left">Esquerda</option>
						<option value="center">Centro</option>
						<option value="right">Direita</option>
					</select>
				</div>
			</>
		)}
	</div>
);

export const CanvasComponent = ({
	canvasRef,
	canvasSize,
	zoom,
	elements,
	selectedElement,
	setSelectedElement,
	handleMouseMove,
	handleMouseUp,
	handleMouseDown,
	handleElementClick,
	deleteElement
}) => (
	<div
		className={styles.canvasContainer}
		onMouseMove={handleMouseMove}
		onMouseUp={handleMouseUp}
	>
		<div
			ref={canvasRef}
			className={styles.canvas}
			style={{
				width: `${canvasSize.width}px`,
				height: `${canvasSize.height}px`,
				transform: `scale(${zoom})`,
				transformOrigin: "top left"
			}}
			onClick={(e) => {
				if (e.target === canvasRef.current)
					setSelectedElement(null);
			}}
		>
			{elements.map((element) => (
				<div
					key={element.id}
					className={`${styles.element} ${
						selectedElement === element.id ? styles.selected : ""
					}`}
					style={{
						left: `${element.x}px`,
						top: `${element.y}px`,
						width: `${element.width}px`,
						height: `${element.height}px`,
						fontSize: `${element.fontSize}px`,
						fontWeight: element.fontWeight,
						fontFamily: element.fontFamily,
						textAlign: element.textAlign,
						textTransform: element.textTransform,
						backgroundColor: element.backgroundColor || "transparent",
						color: element.color || "black",
						display: "flex",
						alignItems: element.alignItems || "center",
						justifyContent: element.textAlign === "center" ? "center" : element.textAlign === "right" ? "flex-end" : "flex-start",
						zIndex: element.zIndex || 0,
						transform: element.transform || "none",
						lineHeight: element.lineHeight || 1.2,
						whiteSpace: element.whiteSpace || "pre-wrap",
						overflow: element.overflow || "visible",
						wordWrap: "break-word",
						hyphens: "auto",
						textOverflow: "clip"
					}}
					onMouseDown={(e) => handleMouseDown(e, element)}
					onClick={(e) => handleElementClick(e, element)}
				>
					{element.type === "text" && (
						<div className={styles.textElement}>
							{element.content}
						</div>
					)}
					{element.type === "image" && (
						<img
							src={element.content}
							alt=""
							className={styles.imageElement}
							draggable={false}
							style={{
								transform: element.transform || "none",
								objectFit: element.objectFit || "contain"
							}}
						/>
					)}
					{element.type === "footer-background" && null}

					{selectedElement === element.id && !(element.isFooterElement && element.type !== "text") && (
						<>
							<button
								className={styles.deleteButton}
								onClick={(e) => {
									e.stopPropagation();
									deleteElement(element.id);
								}}
							>
								×
							</button>
							<div
								className={`${styles.resizeHandle} ${styles.nw}`}
								onMouseDown={(e) => handleMouseDown(e, element, "nw")}
							/>
							<div
								className={`${styles.resizeHandle} ${styles.ne}`}
								onMouseDown={(e) => handleMouseDown(e, element, "ne")}
							/>
							<div
								className={`${styles.resizeHandle} ${styles.sw}`}
								onMouseDown={(e) => handleMouseDown(e, element, "sw")}
							/>
							<div
								className={`${styles.resizeHandle} ${styles.se}`}
								onMouseDown={(e) => handleMouseDown(e, element, "se")}
							/>
						</>
					)}
				</div>
			))}
		</div>
	</div>
);
